export default function includeScript(src) {
  let element = window.document.createElement('script');
  element.setAttribute('src', src);
  window.document.body.appendChild(element);
}
